import React from 'react';
import { usePermissions } from '@/hooks/use-permissions';

interface RequireResourceProps {
  /** Page-type Resource slug, e.g. `assets_page`. */
  slug: string;
  children: React.ReactNode;
}

export function RequireResource({ slug, children }: RequireResourceProps) {
  const { can } = usePermissions();
  if (!can(slug, 'view')) {
    // Centered both axes within the app-shell content area. The shell
    // already has a header bar above; min-h-[70vh] gives enough vertical
    // runway to feel centered without absolute positioning.
    return (
      <div className="flex items-center justify-center min-h-[70vh] p-8">
        <div className="max-w-md text-center space-y-2">
          <h1 className="text-2xl font-semibold">Access denied</h1>
          <p className="text-muted-foreground text-sm">
            Your role does not grant view access to this page. Contact your
            administrator if you believe this is a mistake.
          </p>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
